<template>
	<div class="projectcase">
		
			<div class="img">
				<img :src="banner"/>
			</div>
			<!--路径-->
			<div class="container">
				<div class="path">
					<el-breadcrumb separator-class="el-icon-arrow-right">
					  	<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					  	<el-breadcrumb-item>工程案例</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				
				<!--内容-->
				<div class="content">
					<div class="title">
						<ul>
							<li @click="selItem(item)" 
								:class="sel6===item.title?'active':''" 
								v-for="(item,index) in navlist"
								:key="index" >
								{{item.title}}
							</li>
						</ul>
					</div>
					<router-view/>		
					
				</div>
				
			</div>
			
	
		
	</div>
</template>

<script>
	export default {
		name:'',
		components:{},
		data(){
			return{
				msg:'newcenter',
				navlist: [
							{
								title: '精品案例',
								rou: '/ProjectCase/'
							},
							{
								title: '战略合作',
								rou: '/ProjectCase/Cooperation'
							},
						
				],
				dataList:[],
				sel6:'精品案例',
				sel:'',
				banner:''
			}
		},
		methods:{
			getData(){
				this.sel6 = this.$route.params.sel6;
			},
			selItem(item) {
				this.sel6 = item.title; 
				this.$router.push(item.rou);
			},
			getBanner(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.getBannerApi+'6',
					data: {}
				})
				.then((res) => {
					this.banner = res.data.data.banner6;
				})
				.catch((err) => {
					console.log(err)
				})
			}
		},
		created(){
			this.getData();
			this.getBanner();
		}

	}
</script>

<style lang="less" scoped="scoped">
.projectcase{
	.img{
		width:100%;
		height:350px;
		img{
			width: 100%;
			height: 100%;
		}
	}
	.path{
		margin-top: 20px;
		margin-bottom: 20px;
		i{
			font-size: 20px;
		}
		span{
			color: #00A0FF;
		}
		.news{
			width: 100px;
			height: 40px;
			/*border: 1px solid salmon;*/
			color: forestgreen;
			margin-left: 5px;
			margin-right: 5px;
		}
	}
	.content{
		margin-top: 50px;
		.title{
			text-align: center;
			ul{
				li{
					cursor:pointer;
					display: inline-block;
					margin-left: 40px;
					width: 120px;
					height: 40px;	
					background: #eee;	
					text-align: center;
					line-height: 40px;	
				}
				.active{
					background: #00A0FF;
					color: #fff;
				}
			}
			P{
				margin-top: 50px;
				font-size: 26px;
				color: #00A0FF;
			}
			h3{
				margin-top: 10px;
				font-size: 26px;
				font-weight: 600;
				margin-bottom: 50px;
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/ProjectCase/ProjectCase.vue